import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    name: 'WokFieldset',

    functional: true,

    props: {
        legend: { 
            type: String,
            default: undefined 
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'fieldset', { 
                class: ['wok--fieldset', ctx.data.staticClass],
                attrs: ctx.data.attrs 
            }, [
                hasLegend(ctx) && h('legend', { class: 'wok--fieldset__legend wok--heading-04' }, [
                    ctx.props.legend || ctx.slots().legend
                ]),
                ctx.slots().default
            ]
        )
    }
}

function hasLegend(ctx: RenderContext) {
    return ctx.props.legend || ctx.slots().legend;
}